module.exports = __webpack_public_path__ + "img/banner.f75a7984.png";